"use client";
import React from "react";
import BannerSliderMigration from "@/components/migration/BannerSliderMigration";
import MigrationList from "@/components/migration/MigrationList";
import MigrationForm from "@/components/common/forms/MigrationForm";

const MigrationSectionRenderer = ({ item, index }) => {
    switch (item?.section_data?.template) {
        case 'destination_banner':
            return (
                <React.Fragment key={index}>
                    <BannerSliderMigration data={item}/>
                </React.Fragment>
            );
        case 'partners_list':
            return (
                <React.Fragment key={index}>
                    {
                        item?.section_data?.reverse === 'key1' ?
                            <MigrationList data={item} type/>
                            :
                            <MigrationList data={item}/>


                    }
                </React.Fragment>
            );
        case 'maximax_form':
            return (
                <React.Fragment key={index}>
                    <MigrationForm id={'migration_form'} data={item}/>
                </React.Fragment>
            );
        default:
            return null; // If the template doesn't match any case, render nothing
    }
};

export default React.memo(MigrationSectionRenderer);
